<template>
    <div
        class="filter-modal base-modal"
        :class="modalClasses"
        :style="{
            'min-width': minWidth + 'px',
        }"
        @mouseenter="filterHover = true"
        @mouseleave.self="filterHover = false"
    >
        <div class="modal-header">
            <h5>{{ modalTitle }}</h5>
            <button class="modal-close" @click="$emit('close')">
                {{ filterCloseText ? filterCloseText : 'Close' }}
            </button>
        </div>
        <div class="modal-body">
            <slot @close="$emit('close')"></slot>
        </div>

        <div class="modal-footer">
            <button class="btn btn-secondary" @click="$emit('clear-all')">
                Clear filter
            </button>
            <button class="btn btn-primary" @click="$emit('close')">
                {{ filterCloseText ? filterCloseText : 'Done' }}
            </button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'BaseModal',
    props: {
        modalTitle: String,
        filterCloseText: String,
        filterActive: Boolean,
        minWidth: {
            // type: [Number, Boolean],
            default: 350,
        },
        modalClasses: Array,
        trigger: HTMLButtonElement,
    },
    data() {
        return { filterHover: false };
    },
    methods: {
        clickHandler(e) {
            if (
                e.target == this.trigger ||
                this.filterHover ||
                (e.path && e.path.indexOf(this.trigger) == 1)
            )
                return;

            this.$emit('close', this.filterName);
        },
    },
    beforeMount() {
        window.addEventListener('click', this.clickHandler);
    },
    beforeDestroy() {
        window.removeEventListener('click', this.clickHandler);
    },
};
</script>

<style lang="scss" scoped>
.filter-modal {
    // It gets this from core styles instead
    // position: absolute;
    // top: calc(100% + 25px);
    // left: 0;
    // box-sizing: border-box;
    // display: flex;
    // flex-flow: column nowrap;
    // min-width: 350px;
    // width: 100%;
    // max-width: 375px;
    // background-color: white;
    // opacity: 1;
    // margin: 0 auto;
    // z-index: 10;

    .modal-header {
        display: flex;
        flex-flow: row nowrap;
        justify-content: space-between;
        align-items: center;
        margin: 0;
        padding: 20px;
        border-bottom: 1px solid #b9b9b9;

        h5 {
            margin: 0;
            padding: 0;
            font-weight: 300;
        }

        .modal-close {
            display: inline-flex;
            flex-flow: row nowrap;
            align-items: center;
            padding: 5px;
            margin: 0;
            line-height: 0;
            background: white;
            border: none;
            border-radius: 3.5px;
            font-size: 16px;
            line-height: 15px;

            &:hover {
                background: #e2e2e2;
            }

            &:after {
                content: '\2715';
                display: inline-block;
                font-size: 18px;
                height: 15px;
                width: 15px;
                margin: 0;
                margin-left: 10px;
                padding: 0;
            }
        }
    }

    .modal-footer {
        display: flex;
        flex-flow: row nowrap;
        justify-content: flex-end;
        align-items: center;
        margin: 0;
        padding: 15px 20px;
        border-top: 1px solid #b9b9b9;

        button {
            margin-left: 10px;
        }
    }

    .modal-header,
    .modal-footer {
        &:before,
        &:after {
            content: none !important;
        }
    }
}

.filter-list .modal-body {
    display: flex;
    flex-flow: column nowrap;
    height: 350px;
    overflow-y: scroll;
}
</style>
